import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const COOKIE_CONSENT_KEY = 'autonomous_cookie_consent';

export function hasConsent() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted';
}

export function setConsent(accepted) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(COOKIE_CONSENT_KEY, accepted ? 'accepted' : 'declined');
}

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  
  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay before showing
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);
  
  const handleAccept = () => {
    setConsent(true);
    setShow(false);
  };
  
  const handleDecline = () => {
    setConsent(false);
    setShow(false);
  };
  
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25 }}
          style={{
            position: 'fixed',
            bottom: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            width: 'calc(100% - 48px)',
            maxWidth: '600px',
          }}
        >
          <div style={{
            background: 'rgba(0, 0, 0, 0.95)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            padding: '20px 24px',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.5)',
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '16px',
              flexWrap: 'wrap',
            }}>
              <div style={{ flex: 1, minWidth: '250px' }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#fff',
                  marginBottom: '6px',
                }}>
                  🍪 Vi bruker cookies
                </div>
                <p style={{
                  fontSize: '13px',
                  color: 'rgba(255, 255, 255, 0.6)',
                  margin: 0,
                  lineHeight: 1.5,
                }}>
                  Vi bruker cookies for analyse og for å forbedre din opplevelse. 
                  Ved å fortsette godtar du vår bruk av cookies.
                </p>
              </div>
              
              <div style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
              }}>
                <button
                  onClick={handleDecline}
                  style={{
                    background: 'transparent',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '8px',
                    padding: '10px 16px',
                    fontSize: '13px',
                    color: 'rgba(255, 255, 255, 0.7)',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                  onMouseOver={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
                  onMouseOut={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.2)'}
                >
                  Avslå
                </button>
                <button
                  onClick={handleAccept}
                  style={{
                    background: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontSize: '13px',
                    fontWeight: '500',
                    color: '#000',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                >
                  Godta
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
